import { atom } from "nanostores";

export const isCartOpen = atom(false);
